/**
* @author 贝才[beica1@outook.com]
* @date 2021/3/19
* @description
*   TheSymbolMarketState.vue of WeTrade
*/
<template>
<RealTimeQuote :symbol="symbol" #="{code, price, buy, spread, margin, mp, isRise}">
  <div class="df-middle c-success t-center" :class="{'c-danger': !isRise}">
    <!--<Icon :name="isRise ? 'up' : 'down'" class="badge sm p-0 success"-->
    <!--  :class="{danger: !isRise}" />-->
    <div class="c-text f-bold">{{code}}</div>
    <div class="flex-3 t-left df-middle mx-16">
      {{price}} <span class="diff c-text mx-4"> {{spread}} </span> {{buy}}
    </div>
    <div class="flex-1 t-right">{{margin}}</div>
    <div class="flex-1 t-right ml-16">{{mp}}</div>
  </div>
</RealTimeQuote>
</template>

<script lang="ts">
import RealTimeQuote from '@/provider/RealtimeQuote.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TheSymbolMarketState',
  components: { RealTimeQuote },
  props: {
    symbol: {
      type: Object,
      required: true,
    },
  },
})
</script>

<style scoped lang="scss">
.diff {
  padding: 0 1px;
  font-size: 11px;
  border: 1px solid var(--color-title);
  border-radius: 2px;
}
</style>
